import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { authActions } from "../../store/auth";
import { useNavigate } from "react-router-dom";
import MainHeader from "../../containers/header";
import "./profile.css";

const Profile = (props) => {
  const [profileSelected, setProfileSelected] = useState(""); // value = JSON string
  const [changeLoading, setChangeLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const navigate = useNavigate();
  const { roleList, dispatchChangeRole, user, widthIsSmall } = props;

  const roles = useMemo(() => {
    const list = Array.isArray(roleList) ? roleList : [];
    return [...list].sort((a, b) => Number(a?.loc) - Number(b?.loc));
  }, [roleList]);

  const onRoleChange = () => {
    try {
      setIsError(false);

      if (!profileSelected) {
        setIsError(true);
        return;
      }

      setChangeLoading(true);

      const selected = JSON.parse(profileSelected); // { loc, role, loc_name }

      const updatedUser = {
        ...user,
        role: selected?.role,
        loc: Number(selected?.loc),
        locationName: selected?.loc_name || "",
      };

      dispatchChangeRole(updatedUser);

      setTimeout(() => {
        navigate("/home", { replace: true });
      }, 200);
    } catch (e) {
      setChangeLoading(false);
      setIsError(true);
    }
  };

  useEffect(() => {
    if (changeLoading) {
      const t = setTimeout(() => setChangeLoading(false), 400);
      return () => clearTimeout(t);
    }
  }, [changeLoading]);

  return (
    <div className="profile">
      <MainHeader />
      <div
        className={[
          "d-flex flex-column align-items-center justify-content-center",
          widthIsSmall ? "profile-div-sm" : "profile-div",
        ].join(" ")}
      >
        <div className="profile-head">Change User Profile</div>

        <div className="my-4 w-100">
          <select
            className={[
              "form-select role-select form-select-md",
              isError && "border-red",
            ].join(" ")}
            onChange={(e) => setProfileSelected(e.target.value)}
            value={profileSelected}
          >
            <option disabled value="">
              Select Profile
            </option>

            {roles.map((r, i) => {
              const loc = r?.loc ?? "";
              const role = r?.role ?? "";
              const locName = r?.loc_name || ""; // ✅ no undefined

              return (
                <option
                  className="profile-option"
                  key={`${loc}-${role}-${i}`}
                  value={JSON.stringify({ loc, role, loc_name: locName })}
                >
                  {locName
                    ? `${loc} ${role} - ${locName}`
                    : `${loc} ${role}`}
                </option>
              );
            })}
          </select>

          {isError && (
            <div className="error-text text-end">Please select profile</div>
          )}
        </div>

        <button
          className="btn btn-logout d-flex align-items-center"
          disabled={changeLoading}
          onClick={onRoleChange}
        >
          <div>Change Profile</div>
          {changeLoading && <div className="ms-2 spinner"></div>}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  roleList: state?.auth?.user?.roleList,
  widthIsSmall: state?.auth?.widthIsSmall,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchChangeRole: (data) => dispatch(authActions.changeRole(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);